// The category list does not return a color yet, so each row takes one from a
// small token-backed palette by a stable index. The color is derived
// client-side until the backend returns a color field.
/* @ds-deviation: category colors are not part of the DS token set — proposed resolution: promote a tag palette into the design system */
const CATEGORY_COLOR_CLASSES = [
  "bg-primary",
  "bg-secondary",
  "bg-tertiary",
  "bg-error",
] as const;

export function categoryColorClass(categoryId: number) {
  return CATEGORY_COLOR_CLASSES[categoryId % CATEGORY_COLOR_CLASSES.length];
}
